import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Cube, CheckCircle, WarningCircle, CircleNotch } from "@phosphor-icons/react";

import { useI18n } from "@/lib/i18n";
export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const called = useRef(false);

  useEffect(() => {
    if (!token) { setStatus("error"); setErr(t("final.verify_missing")); return; }
    if (called.current) return;
    called.current = true;
    (async () => {
      try {
        const r = await api.post("/auth/verify-email", { token });
        setEmail(r.data?.email || "");
        setStatus("ok");
        setTimeout(() => nav("/login"), 2500);
      } catch (e) {
        setStatus("error");
        setErr(e.response?.data?.detail || t("final.verify_failed"));
      }
    })();
  }, [token, nav]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12" data-testid="verify-email-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-sm p-6 sm:p-10 shadow-sm text-center">
        <div className="inline-flex items-center gap-2 mb-6">
          <div className="w-10 h-10 bg-[#2563EB] flex items-center justify-center rounded-sm">
            <Cube weight="bold" size={22} className="text-white" />
          </div>
          <div className="text-left">
            <div className="font-display font-extrabold text-lg leading-4">H3POE</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">{t("verify.title")}</div>
          </div>
        </div>

        {status === "loading" && (
          <div className="py-8" data-testid="verify-loading">
            <CircleNotch size={40} weight="bold" className="text-[#2563EB] animate-spin mx-auto" />
            <div className="mt-4 text-sm text-slate-600">{t("verify.verifying")}</div>
          </div>
        )}

        {status === "ok" && (
          <div className="py-8" data-testid="verify-success">
            <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
              <CheckCircle size={40} weight="fill" className="text-emerald-600" />
            </div>
            <h1 className="mt-4 font-display font-extrabold text-2xl">{t("verify.success")}</h1>
            <p className="mt-2 text-sm text-slate-600">
              {email && <><span className="font-mono">{email}</span> için</>} hesabınız etkinleştirildi. Şimdi giriş yapabilirsiniz.
            </p>
            <div className="mt-4 text-xs text-slate-400">{t("verify.redirect")}</div>
          </div>
        )}

        {status === "error" && (
          <div className="py-8" data-testid="verify-error">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto">
              <WarningCircle size={40} weight="fill" className="text-red-600" />
            </div>
            <h1 className="mt-4 font-display font-extrabold text-2xl">{t("verify.failed")}</h1>
            <p className="mt-2 text-sm text-slate-600">{err}</p>
            <button onClick={() => nav("/login")}
              className="mt-6 inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-4 py-2 text-sm font-semibold rounded-sm">
              Girişe Dön
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
